export default __webpack_public_path__ + "assets/e28078a66f49002c5f63214671c00b72.svg";